<siat-select-field
  [ngClass]="containerClass()"
  [formGroup]="parentFormgroup()"
  [controlName]="regioniControlName()"
  [id]="id + regioniControlName()"
  [name]="regioniControlName()"
  placeholder="{{ 'FIELDS.REGIONE.placeholder' | translate }}"
  label="{{ 'FIELDS.REGIONE.label' | translate }}"
  [items]="regioniProvinceComuniStore.regioniItems()"
></siat-select-field>

<siat-select-field
  [ngClass]="containerClass()"
  [formGroup]="parentFormgroup()"
  [controlName]="provinciaControlName()"
  [id]="id + provinciaControlName()"
  [name]="provinciaControlName()"
  placeholder="{{ 'FIELDS.PROVINCIA.placeholder' | translate }}"
  label="{{ 'FIELDS.PROVINCIA.label' | translate }}"
  [items]="regioniProvinceComuniStore.provinceItems()"
></siat-select-field>

<div [ngClass]="containerClass()">
  <siat-select-field
    [formGroup]="parentFormgroup()"
    [controlName]="comuneControlName()"
    [id]="id + comuneControlName()"
    [name]="comuneControlName()"
    placeholder="{{ 'FIELDS.COMUNE.placeholder' | translate }}"
    label="{{ 'FIELDS.COMUNE.label' | translate }}"
    [items]="regioniProvinceComuniStore.comuniItems()"
  ></siat-select-field>
</div>
